import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

const bankProjectedReportKeys = {
  all: ['bankProjectedReports'],
  report: (filtersKey) => [...bankProjectedReportKeys.all, 'report', filtersKey],
};

export const useBankProjectedReport = (filters, options = {}) => {
  return useQuery({
    queryKey: bankProjectedReportKeys.report(filters ? JSON.stringify(filters) : 'initial'),
    queryFn: async () => {
      if (!filters) {
        return null;
      }
      const response = await apiClient.post('bank_projected_reports/report', filters);
      return response.data;
    },
    enabled: false,
    ...options,
  });
};

export { bankProjectedReportKeys };
